@if (visible()) {
  <!-- No modal (W6): tarjeta anclada abajo, sin robar el foco ni bloquear la página. -->
  <aside
    class="nl-popup"
    aria-labelledby="nl-popup-title"
    aria-describedby="nl-popup-body"
    (keydown.escape)="close()"
  >
    <button
      type="button"
      class="nl-popup__close"
      [attr.aria-label]="copy.POPUP_CLOSE_LABEL"
      (click)="close()"
    >
      <app-icon [icon]="closeIcon" [size]="18" aria-hidden="true" />
    </button>

    <h2 id="nl-popup-title" class="nl-popup__title">{{ copy.POPUP_TITLE }}</h2>
    <p id="nl-popup-body" class="nl-popup__body">{{ copy.POPUP_BODY }}</p>

    <app-newsletter-form
      variant="popup"
      inputId="popup-newsletter-email"
      placeholder="tu@correo.com"
      ctaLabel="Suscribirme"
    />

    <button type="button" class="nl-popup__dismiss" (click)="close()">
      {{ copy.POPUP_DISMISS }}
    </button>
  </aside>
}
